import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ZHB_STEP_PREFIX } from './const';
import { ZhbStepListItem } from './item';
export var ZhbStepList = function ZhbStepList(props) {
  var dts = props.dts;
  return React.createElement("div", {
    className: ZHB_STEP_PREFIX
  }, dts.map(function (item, idx) {
    var _a;
    return React.createElement(ZhbStepListItem, _extends({
      key: idx
    }, item, {
      indicator: (_a = item.indicator) !== null && _a !== void 0 ? _a : idx + 1
    }));
  }));
};